export const ROLES = ["contestant"];

export const POSITIONS = ["Designer", "Developer"];

export const STUDY_YEARS = ["1", "2", "3", "4", "more", "Graduate"];

export const JOB_STATUS = [
  "Employed full-time",
  "Employed part-time", 
  "Freelancer",
  "Currently not working",
  "Student"
];

export const FIELDS_INTEREST = [
  "Cyber Security",
  "Game Development",
  "Game Art",
  "Game Design",
  "Devops / Cloud",
  "Backend",
  "Frontend",
  "QA (Testing)",
  "UI / UX",
  "Mobile Dev (Cross Platform)",
  "Android",
  "IOS",
  "Machine Learning",
  "Model Data",
  "Robotics",
  "IOT",
  "Other",
];

export const AWARENESS_CHANNELS = [
  "From Our WhatsApp Community",
  "From Our Website",
  "From Linkedin",
  "From Instagram",
  "From Facebook",
  "From University",
  "From Friends",
  "From Eqraatech - اقرأ-تِك",
  "From Qabilah - قبيلة",
  "Other",
];

export const EXPERIENCE_LEVELS = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10
];
